import { render, staticRenderFns } from "./BigSlider.vue?vue&type=template&id=ca05039c&"
import script from "./BigSlider.vue?vue&type=script&lang=js&"
export * from "./BigSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports